import { useState } from "react";
import { X, Plus, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { pct, shortCat } from "@/lib/format";
import { TYPES, COLORS, keyOf } from "@/components/compare/config";
import { ItemPicker } from "@/components/compare/ItemPicker";

const Filled = ({ x, i, type, onRemove, onChoose }) => {
  const t = TYPES[type];
  return (
    <div data-testid={`compare-slot-${i}`} className="relative rounded-2xl bg-white border border-slate-200 shadow-sm overflow-hidden flex flex-col rise" style={{ animationDelay: `${i * 70}ms` }}>
      <div className="h-1.5" style={{ background: COLORS[i] }} />
      <div className="p-5 flex-1 flex flex-col">
        <button data-testid={`compare-remove-${keyOf(x)}`} onClick={onRemove} className="absolute top-4 right-3 p-1 rounded-full text-slate-400 hover:text-slate-900 hover:bg-slate-100" aria-label="Remove"><X className="w-4 h-4" /></button>
        <span className="font-mono text-xs font-bold" style={{ color: COLORS[i] }}>OPTION {String.fromCharCode(65 + i)}</span>
        <p className="font-display font-extrabold text-lg leading-tight mt-1 pr-6">{x.name}</p>
        <p className="text-xs text-slate-500 mt-1">{t.fund ? `${shortCat(x.category)} · ${x.amc}` : t.sub(x)}</p>
        {t.fund && <p className="mt-4 font-mono text-2xl font-bold">{pct(x.r3y)} <span className="text-xs font-sans font-semibold text-slate-400">3Y CAGR</span></p>}
        <button data-testid={`compare-choose-${keyOf(x)}`} onClick={onChoose} className="mt-auto pt-4">
          <span className="flex items-center justify-center gap-2 h-11 rounded-xl bg-[#1E293B] hover:bg-[#0F172A] text-white font-bold text-sm transition-colors">Choose this <ArrowRight className="w-4 h-4" /></span>
        </button>
      </div>
    </div>
  );
};

export const Slots = ({ items, type, pool, ids, setIds, onChoose }) => {
  const [open, setOpen] = useState(false);
  const t = TYPES[type];
  const add = (id) => { if (!ids.includes(id) && ids.length < 3) setIds([...ids, id]); setOpen(false); };
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((x, i) => <Filled key={keyOf(x)} x={x} i={i} type={type} onRemove={() => setIds(ids.filter((c) => c !== keyOf(x)))} onChoose={() => onChoose(x)} />)}
      {Array.from({ length: 3 - items.length }).map((_, i) => (
        <button key={i} data-testid={`compare-add-slot-${i}`} onClick={() => setOpen(true)}
          className="min-h-[220px] rounded-2xl border-2 border-dashed border-slate-300 bg-white/60 hover:border-[#10B981] hover:bg-emerald-50/50 flex flex-col items-center justify-center gap-2 text-slate-500 hover:text-[#059669] transition-colors">
          <span className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center"><Plus className="w-6 h-6" /></span>
          <span className="font-bold">Add {items.length + i === 0 ? t.article || "a" : "one more"} {t.noun}</span>
          <span className="text-xs">Option {String.fromCharCode(65 + items.length + i)}</span>
        </button>
      ))}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="compare-add-dialog" className="bg-white rounded-2xl max-w-2xl w-[94vw]">
          <DialogHeader><DialogTitle className="font-display text-xl">Add {t.article || "a"} {t.noun} to compare</DialogTitle></DialogHeader>
          <ItemPicker type={type} pool={pool} ids={ids} onPick={add} compact />
        </DialogContent>
      </Dialog>
    </div>
  );
};
